import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';

const Media = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  /**
   * 동영상을 출력하는 템플릿.
   */

  try {
    return (
      <div className="_message_set_button_type2">
          <div className="_media_type" style={boxStyle}>
            {ReactHtmlParser(item.value)}
          </div>
      </div>
    );
  } catch (e) {
    console.log(e);
  }
};
Media.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
Media.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

export default Media;
